<template>
  <div class="document-card">
    <div class="tags">
      <div class="tag on" v-if="content.status === 1">
        <span>已发布</span>
      </div>
      <div class="tag off" v-if="content.status === 0">
        <span>未发布</span>
      </div>
    </div>
    <div class="sorts">
      <el-button
        circle
        size="mini"
        icon="el-icon-back"
        :disabled="noUp"
        title="排序前"
        @click="handleSortChange(content, 'up')"
      ></el-button>
      <el-button
        circle
        size="mini"
        icon="el-icon-right"
        :disabled="noDown"
        title="排序后"
        @click="handleSortChange(content, 'down')"
      ></el-button>
    </div>
    <div class="content-wrap">
      <div class="left">
        <img
          :src="content.pictures[0] ? content.pictures[0].picture_url : ''"
        />
      </div>
      <div class="right">
        <p class="title" :title="content.name">{{ content.name }}</p>
        <div class="text">
          <span>{{ content.service }}</span>
        </div>
        <div class="count">
          <span class="old-price">¥{{ content.market_price }}</span>
          <span>{{ content.user_count || 0 }}人购买</span>
        </div>
        <div class="price">
          <span class="new-price">¥{{ content.price }}</span>
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="menu-item">
        <router-link :to="`/material/edit/${content.id}`">
          <i class="el-icon-edit"></i>
          <span>编辑</span>
        </router-link>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToPreview">
        <i class="el-icon-zoom-in"></i>
        <span>浏览</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handelMaterialRemove">
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "document-card",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noUp: false,
    noDown: false,
  },
  data() {
    return {};
  },
  methods: {
    handelMaterialRemove() {
      this.$emit("remove", this.content.id);
    },
    // 预览
    handleToPreview() {
      /*   if (this.content && this.content.subjects && this.content.subjects[0]) {
        if (location.host.includes("admin.koudaikaoyan.com")) {
          window.open(
            `https://www.koudaikaoyan.com/subject/${this.content.subjects[0].id}/material/${this.content.id}`
          );
        } else {
          window.open(
            `http://test.koudaikaoyan.com/subject/${this.content.subjects[0].id}/material/${this.content.id}`
          );
        }
      } */
      if (this.content) {
        if (location.host.includes("admin.kaoyanbox.com")) {
          window.open(
            `https://h5.kaoyanbox.com/material/detail/${this.content.id}`
          );
        } else {
          window.open(
            `http://h5.kaoyanbox.net/material/detail/${this.content.id}`
          );
        }
      }
    },
    // 排序位置变化
    handleSortChange(row, sort) {
      this.$emit("sort", row, sort);
    },
  },
};
</script>

<style lang="less" scoped>
.document-card {
  position: relative;
  width: 260px;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 30px 10px 0px;
  overflow: hidden;

  &:hover {
    .sorts {
      display: block;
    }
  }

  a {
    text-decoration: none;
    color: #303133;
  }

  .tags {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      background: #ff6600;
      border-radius: 5px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 0px;
      font-size: 12px;
      color: #fff;
      padding: 3px 10px;

      &:not(:first-child) {
        margin-left: 5px;
      }
      &.on {
        background: #409eff;
      }
    }
  }

  .sorts {
    display: none;
    position: absolute;
    right: 5px;
    top: 2px;

    button {
      padding: 2px;
    }
  }

  .content-wrap {
    display: flex;

    .left {
      margin-right: 10px;
    }
    .right {
      flex: 1;
      overflow: hidden;
    }
    img {
      width: 90px;
      height: 90px;
      object-fit: cover;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .text {
      margin-top: 5px;
      font-size: 12px;
      color: #669900;

      span:not(:first-child) {
        margin-left: 5px;
      }
    }
    .count {
      margin-top: 10px;
      font-size: 12px;

      span:not(:first-child) {
        margin-left: 5px;
      }
    }
    .old-price {
      text-decoration: line-through;
      color: #999;
    }
    .new-price {
      margin-top: 2px;
      color: #f00;
    }
    .price {
      margin-top: 15px;
      font-weight: bold;
    }
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    margin: 10px -10px 0;

    .menu-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 10px 20px;

      i {
        margin-right: 2px;
      }
    }
    .divider {
      height: 20px;
      border-right: 1px solid #ccc;
    }
  }
}
</style>
